import React, {useState} from "react";
import { CustomButton } from "components";
import "./style.scss";

const CardOnDemand = ({
  data,
  clickCardOnDemand = async () => {},
  openModalContent = () => {},
  userProfile,
}) => {
  const [loading, setLoading] = useState(false)
  const { title, courseImage:image, enroll } = data;

  return (
    <>
      <div className="container-card-certificate">
        <div className="container-image">
          <img src={image} alt="container-situation"></img>
        </div>
        <div className="container-content">
          <p
            style={{
              color: "black",
              fontSize: "24px",
              margin: "0px",
              padding: "0px",
              marginBottom: "5px",
              textAlign: "center",
            }}
          >
            {title}
          </p>
          <CustomButton
            className="special-card-button"
            text={enroll ? 'Continue' : 'Explore More'}
            type={enroll ? "secondary" : "primary"}
            size="md"
            onClick={async () => {
              setLoading(true);
              await clickCardOnDemand(data);
              setLoading(false)
            }}
            loading={loading}
          />
          {userProfile?.role === 'admin' && <div
            onClick={() => openModalContent(data)}
            style={{ background: "#fe5621", padding: "8px 17px" }}
            className="button-card-certificate"
          >
            Data Static
          </div>}
          {userProfile?.role === 'admin' && <div
            onClick={() => clickCardOnDemand(data,true)}
            style={{ background: "#fe5621", padding: "8px 17px" }}
            className="button-card-certificate"
          >
            See Page Information
          </div>}
        </div>
      </div>
    </>
  );
};

export default CardOnDemand;
